import { render, staticRenderFns } from "./modalAlterarDataAgendamento.vue?vue&type=template&id=46c4bcb8"
import script from "./modalAlterarDataAgendamento.vue?vue&type=script&lang=js"
export * from "./modalAlterarDataAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports